export const mapGradYearsToClassYearNames = (seniorGradYear, gradYearCounts) => {
  const gradYearToClassNameMap = getClassNameToGradYearMap(seniorGradYear)
  const zeroValue = {
    counts: {
      college_reached_count: 0,
    },
  }
  const findByClassName = (gradYearsCounts, className) =>
    gradYearsCounts.find(({ grad_year }) => grad_year === gradYearToClassNameMap[className.toLowerCase()]) || zeroValue
  const getCount = (gradYearsCounts, className) =>
    findByClassName(gradYearsCounts, className).counts.college_reached_count

  return {
    seniors: getCount(gradYearCounts, 'Seniors'),
    juniors: getCount(gradYearCounts, 'Juniors'),
    sophomores: getCount(gradYearCounts, 'Sophomores'),
    freshmen: getCount(gradYearCounts, 'Freshmen'),
  }
}
const getClassNameToGradYearMap = (seniorGradYear) => ({
  seniors: seniorGradYear,
  juniors: seniorGradYear + 1,
  sophomores: seniorGradYear + 2,
  freshmen: seniorGradYear + 3,
})

export const getGradYearToClassNameMap = (seniorGradYear) => ({
  [seniorGradYear]: 'Seniors',
  [seniorGradYear + 1]: 'Juniors',
  [seniorGradYear + 2]: 'Sophomores',
  [seniorGradYear + 3]: 'Freshmen',
})

export const colors = {
  seniors: '#32B4F2',
  juniors: '#FF2C84',
  sophomores: '#FFB75F',
  freshmen: '#6FB963',
}

export const getColorByGradYear = (seniorGradYear, gradYear) => {
  const gradYearToClassNameMap = getClassNameToGradYearMap(seniorGradYear)
  const colorsByGradYear = {
    [gradYearToClassNameMap.seniors]: colors.seniors,
    [gradYearToClassNameMap.juniors]: colors.juniors,
    [gradYearToClassNameMap.sophomores]: colors.sophomores,
    [gradYearToClassNameMap.freshmen]: colors.freshmen,
  }
  return colorsByGradYear[gradYear]
}
